export default __webpack_public_path__ + "static/media/639-6399637_henry-circle-gentleman.00c73532.png";